<template>
  <div>game area</div>
</template>
<script>
export default {
  components: {},
};
</script>